import React from 'react'
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';

const MyButton = ({ children, tip, tipClassName, onClick, btnClassName, ...iconButtonProps }) => (
    <Tooltip title={tip} className={tipClassName} placement="top">
        <IconButton onClick={onClick} className={btnClassName} {...iconButtonProps}>
            {children}
        </IconButton>
    </Tooltip>
);

export default MyButton;
